import {
  _THEME,
  accentColor,
  deskQuery,
  errorColor,
  greenColor,
  grey1,
  grey3,
  grey4,
  grey5,
  grey6,
  lg1,
  lg2,
  lg3,
  mainColor,
  mainColor2,
  mainColor3,
  md1,
  md2,
  md3,
  mobileQuery,
  shadow1,
  shadow9,
  sm1,
  sm2,
  sm3,
  tabQuery,
  white,
} from "../../theme";

export const _STYLES = {
  container: {
    maxWidth: "100%",
    margin: "0 auto",
    padding: "0 1rem",
    "@media (min-width: 476px)": {
      width: "100%",
    },
    " @media (min-width: 768px)": {
      width: 750,
    },
    "@media (min-width: 992px)": {
      width: 970,
    },
    "@media (min-width: 1200px)": {
      width: "95%",
      maxWidth: 1400,
    },
  },
  mainColor: _THEME.color.primary.main,
  customFont: {
    fontFamily: "Share Tech Mono, sans-serif !important",
    textTransform: "uppercase",
    letterSpacing: 4,
    fontWeight: 600,
  },
  mainHeader: {
    fontSize: lg2,
    lineHeight: 1.3,
    [tabQuery]: {
      fontSize: md3,
    },
    [mobileQuery]: {
      fontSize: md2,
    },
  },
  sectionHeader: {
    fontSize: lg1,
    [tabQuery]: {
      fontSize: md2,
    },
    [mobileQuery]: {
      fontSize: md1,
    },
    lineHeight: 1.3,
  },
  miniHeader: {
    fontSize: md1,
    [tabQuery]: {
      fontSize: sm3,
    },
    [mobileQuery]: {
      fontSize: sm2,
    },
    lineHeight: 1.3,
  },
  normalHeader: {
    fontSize: md1,
    [tabQuery]: {
      fontSize: sm3,
    },
    [mobileQuery]: {
      fontSize: sm2,
    },
    lineHeight: 1.3,
    fontWeight: 400,
  },
  filterHeader: {
    fontSize: sm3,
    [tabQuery]: {
      fontSize: sm2,
    },
    [mobileQuery]: {
      fontSize: sm1,
    },
    fontWeight: 500,
  },
  subHeader: {
    fontSize: md3,
    [tabQuery]: {
      fontSize: md1,
    },
    [mobileQuery]: {
      fontSize: sm3,
    },
  },
  colorPrimary: {
    color: mainColor,
  },
  colorAccent: {
    color: accentColor,
  },
  colorError: {
    color: errorColor,
  },
  colorText: {
    color: grey4,
  },
  colorSubText: {
    color: grey5,
  },
  padTopXl: {
    paddingTop: 120,
    [tabQuery]: {
      paddingTop: 60,
    },
  },
  padTopLg: {
    paddingTop: 90,
    [tabQuery]: {
      paddingTop: 40,
    },
  },
  padTopMd: {
    paddingTop: 60,
    [tabQuery]: {
      paddingTop: 40,
    },
  },
  padTopSm: {
    paddingTop: 40,
    [tabQuery]: {
      paddingTop: 20,
    },
  },
  padBottomXl: {
    paddingBottom: 120,
    [tabQuery]: {
      paddingBottom: 60,
    },
  },
  padBottomLg: {
    paddingBottom: 90,
    [tabQuery]: {
      paddingBottom: 40,
    },
  },
  padBottomMd: {
    paddingBottom: 60,
    [tabQuery]: {
      paddingBottom: 40,
    },
  },
  padBottomSm: {
    paddingBottom: 40,
    [tabQuery]: {
      paddingBottom: 20,
    },
  },

  paraLine: {
    lineHeight: 1.75,
  },
  headerLine: {
    lineHeight: 1.5,
  },
  textSm1: {
    fontSize: sm1,
  },
  textSm2: {
    fontSize: sm2,
    [tabQuery]: {
      fontSize: sm1,
    },
  },
  textSm3: {
    fontSize: sm3,
    [tabQuery]: {
      fontSize: sm2,
    },
    [mobileQuery]: {
      fontSize: sm1,
    },
  },
  textMd1: {
    fontSize: md1,
    [tabQuery]: {
      fontSize: sm3,
    },

    [mobileQuery]: {
      fontSize: sm2,
    },
  },
  textMd2: {
    fontSize: md2,
    [tabQuery]: {
      fontSize: md1,
    },
    [mobileQuery]: {
      fontSize: sm3,
    },
  },
  textMd3: {
    fontSize: md3,
    [tabQuery]: {
      fontSize: md2,
    },
    [mobileQuery]: {
      fontSize: md1,
    },
  },
  textLg1: {
    fontSize: lg1,
    [tabQuery]: {
      fontSize: md3,
    },
    [mobileQuery]: {
      fontSize: md2,
    },
  },
  textLg2: {
    fontSize: lg2,
    [tabQuery]: {
      fontSize: lg1,
    },
    [mobileQuery]: {
      fontSize: md3,
    },
  },
  textLg3: {
    fontSize: lg3,
    [tabQuery]: {
      fontSize: lg2,
    },
    [mobileQuery]: {
      fontSize: lg1,
    },
  },
  fontLight: {
    fontWeight: 300,
  },
  fontRegular: {
    fontWeight: 400,
  },
  fontMid: {
    fontWeight: 500,
  },
  pb0: {
    paddingBottom: "0 !important",
  },
  fontBold: {
    fontWeight: 600,
  },
  mt1: {
    marginTop: "1rem",
  },
  mt2: {
    marginTop: "2rem",
  },
  opacity80: {
    opacity: "0.8",
  },
  m0: {
    margin: "0 !important",
  },
  mb0: {
    marginBottom: 0,
  },
  mb1: {
    marginBottom: "1rem",
  },
  mb2: {
    marginBottom: "2rem",
  },
  logo: {
    height: 50,
    [tabQuery]: {
      height: 40,
    },
  },
  bgGrey: {
    background: grey1,
  },
  bgWhite: {
    background: grey6,
  },
  bgBlue: {
    background: mainColor2,
  },
  h100: {
    height: "100%",
  },
  textCenter: {
    textAlign: "center",
  },
  surveyImg: {
    display: "flex",
    margin: "2rem auto",
  },
  textLeft: {
    textAlign: "left",
  },
  textRight: {
    textAlign: "right",
  },
  colorLight: {
    color: "#fff",
  },
  w100: {
    width: "100%",
  },
  noWrap: {
    whiteSpace: "nowrap",
  },
  breakWord: {
    wordBreak: "break-all",
  },
  blockBordered: {
    border: "16px solid rgb(0 103 108 / 20%)",
  },
  bgAccent: {
    background: accentColor,
  },
  bgPrimary: {
    background: mainColor,
  },
  mxAuto: {
    marginLeft: "auto",
    width: "max-content",
    marginRight: "auto",
    display: "block",
    maxWidth: "100%",
  },
  mlAuto: {
    marginLeft: "auto",
    width: "max-content",
    display: "block",
    maxWidth: "100%",
  },
  overflowHidden: {
    overflow: "hidden",
  },
  pRelative: {
    position: "relative",
  },
  px1: {
    paddingLeft: "1rem",
    paddingRight: "1rem",
  },
  py1: {
    paddingTop: "1rem",
    paddingBottom: "1rem",
  },
  verticalDivider: {
    textAlign: "center",
    "& > div": {
      height: "100%",
    },
  },
  modalContainer: {
    paddingTop: "1rem",
    paddingBottom: "1rem",
    overflowX: "auto",
  },
  bodyWrap: {
    height: "100vh",
  },
  dashboardContainer: {
    // background: accentColor2,
    // padding: "1rem",
  },
  dashboardInner: {
    background: white,
    borderRadius: 8,
    height: "100%",
    overflow: "hidden",
  },
  dashboardMid: {
    background: mainColor2,
    padding: "2rem",
    [tabQuery]: {
      padding: "1.5rem",
    },
    minHeight: "calc(100vh - 75px)",
    maxHeight: "calc(100vh - 75px)",
    overflowY: "auto",
    height: "100%",
  },
  dashboardWrap: {
    height: "100%",
  },
  dashLeft: {
    padding: "0 0 2rem",
    background: grey6,
    [tabQuery]: {
      position: "fixed",
      zIndex: 15,
      height: "calc(100vh - 75px)",
      top: "75px",
      right: 0,
      animation:
        "slide-in-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
  },
  underLay: {
    all: "unset",
    zIndex: 10,
    position: "fixed",
    width: "100%",
    height: "100%",
    top: 75,
    left: 0,
    right: 0,
    background: "rgb(0, 0, 0, 0.2)",
    animation: " fade-in 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both",
  },

  navBtnOpen: {
    position: "fixed",
    left: 0,
    top: 75,
    zIndex: 10,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  navBtnClose: {
    position: "absolute",
    right: "-32px",
    top: "0",
    borderTopLeftRadius: "0",
    borderBottomLeftRadius: "0",
  },
  dashRight: {
    padding: "2rem 0",
    background: grey6,
  },
  dashHeader: {
    width: "100%",
    padding: "1rem",
    height: 75,
  },
  segmentWrap: {
    border: `1px solid ${mainColor3}`,
  },
  fillGrey: {
    "& svg": {
      fill: grey3,
    },
  },

  subText: {
    fontSize: sm2,
    lineHeight: 1.75,
    fontWeight: 400,
    color: grey4,
    [tabQuery]: {
      fontSize: sm1,
    },
  },
  subTextHeader: {
    fontSize: sm2,
    lineHeight: 1.75,
    fontWeight: 500,
    color: grey4,
    [tabQuery]: {
      fontSize: sm1,
    },
  },
  radioCardWrap: {
    width: "100%",
    "&>.ant-radio": {
      position: "absolute",
      left: "1rem",
      zIndex: 1,
    },
    "&>span:last-of-type": {
      width: "100%",
      padding: 0,
    },
    "& .ant-card-body": {
      padding: 12,
      textAlign: "center",
    },

    "& .ant-radio-checked": {
      border: `2px solid #fff`,
    },
    "&.ant-radio-wrapper-checked": {
      "& .ant-card-body": {
        backgroundColor: mainColor,
      },
      "& .ant-statistic-content": {
        color: white,
        fontWeight: 400,
      },
    },
  },
  radioCard: {
    borderColor: mainColor,
    "&:not(.ant-card-bordered)": {
      border: `1px solid ${grey1}`,
      //boxShadow: `${shadow1} !important`,
    },
    "& .ant-statistic-content": {
      fontSize: sm3,
    },
  },
  avatarIconBg: {
    color: "#f4b42c",
    backgroundColor: "#fefbda",
  },
  transparentBlock: {
    width: "100%",
    position: "relative",
    padding: "2rem",
    borderRadius: 16,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    background: grey6,
    border: `1px solid ${mainColor3}`,
    [mobileQuery]: {
      padding: "1rem",
    },
  },
  inlineBadge: {
    display: "flex",
    alignItems: "center",
  },
  icon: {
    width: 14,
    height: 14,
  },
  link: {
    all: "unset",
    cursor: "pointer",
    "&:hover": {
      all: "unset",
      cursor: "pointer",
    },
  },
  pieContainer: {
    height: 300,
  },
  dataCard: {
    background: "#ffffff",
    border: "none",
    borderRadius: 16,
    boxShadow: "0 2px 12px rgba(27,42,107,0.08)",
    padding: "1.25rem 1.5rem",
    width: "100%",
    [mobileQuery]: {
      padding: "0.75rem 1rem",
    },
  },
  flexGrow: {
    flex: 1,
  },
  menuLoad: {
    width: "100%",
    padding: 8,
  },
  menuSkel: {
    height: 40,
    width: "100%",
    borderRadius: 8,
  },
  uploadLogo: {
    fontSize: 32,
  },
  errorBanner: {
    background: errorColor,
    padding: "0.5rem 0.75rem",
    borderRadius: 8,
    "& *": {
      color: `${white} !important`,
    },
  },
  inputIconColor: {
    color: "rgba(0,0,0,.25)",
  },
  btnSuccess: {
    backgroundColor: `${greenColor} !important`,
  },
  btnError: {
    backgroundColor: `${errorColor} !important`,
  },
  menu: {
    "&.ant-menu-inline-collapsed .ant-menu-item": {
      paddingInline: 8,
      width: "max-content",
    },
  },
  scrollableYContainer: {
    background: white,
    overflowY: "auto",
    padding: "1rem",
    borderRadius: 12,
  },
  br12: {
    borderRadius: 12,
  },
  documentStatusIndicator: {
    display: "block",
    borderRadius: "50%",
    width: 32,
    height: 32,
    backgroundColor: greenColor,
  },
  downloadBtn: {
    backgroundColor: `${greenColor} !important`,
    "&:hover": {
      filter: "brightness(1.1)",
    },
  },
  carouselDots: {
    "& button": {
      background: `${mainColor} !important`,
    },
    "& .slick-active button": {
      background: `${accentColor} !important`,
    },
  },
  resetStyles: {
    "& ul, & ol": {
      padding: "revert",
      listStyleType: "auto",
    },
    "& li": {
      listStyleType: "auto",
    },
  },
  textEllipsis: {
    whiteSpace: "nowrap",
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
};
